import React, { useState } from "react";
import styles from "../Faqs/Faqs.module.css";
import Faqs_Data from "../../Data/RO-landing.json";
import { json } from "react-router-dom";

const Faqs = () => {
  // retrieving faqs data from json...
  let faqs_Data = Faqs_Data[0].faq;

  // setting first time rendering to 3 limits...
  const [limit, setLimit] = useState(3);
  return (
    <div className={styles.container}>
      <h2 className={styles.faqs_heading}>Frequently Asked Questions?</h2>
      <div>
        {faqs_Data?.slice(0, limit).map((data, index) => {
          return (
            <>
              <details className={styles.faqCard}>
                <summary className={styles.question}>
                  <p>+</p> {data.question}
                </summary>
                <span className={styles.answer}>{data.answer}</span>
              </details>
            </>
          );
        })}
      </div>
      <button
        id={styles.moreBtn}
        onClick={() => {
          setLimit(limit + 3);
        }}
      >
        More Faqs ?
      </button>
    </div>
  );
};

export default Faqs;
